<template>
  <router-link
    :exact="!matchChildrenRoutes"
    tag="li"
    class="NavLinkMobile"
    :to="{
      name: to,
      params: {
        actor: selectedActor && selectedActor.pathArr,
        landscapeSlug: $route.params.landscapeSlug
      }
    }"
  >
    <a>
      <lm-icon v-if="svg" :icon="icon" svg class="text-gray-300" />
      <lm-material-icon v-else :icon="icon" />
      <span class="Label">{{ label }}</span>
    </a>
  </router-link>
</template>

<script>
import LmIcon from '@/components/ui/LmIcon'
import {mapGetters} from 'vuex'
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'

export default {
  name: 'NavLinkMobile',
  components: {LmIcon, LmMaterialIcon},
  props: {
    to: {
      type: String,
      required: true
    },
    matchChildrenRoutes: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    svg: {
      type: Boolean,
      default: false
    }
  },
  computed: mapGetters(['selectedActor'])
}
</script>

<style scoped>
.NavLinkMobile {
  @media (min-width: 360px) {
    min-width: 65px;
  }
  @media (min-width: 400px) {
    min-width: 75px;
  }
  @media (min-width: 450px) {
    min-width: 90px;
  }
  font-size: 11px;
  a {
    display: block;
    padding: 0 10px;
    text-align: center;
    color: theme('colors.gray.300');
    &:hover {
      text-decoration: none;
    }
  }
  &.router-link-active {
    a,
    a svg {
      color: theme('colors.highlight');
    }
  }
  .Label {
    display: block;
  }
}
</style>
